import { Map } from "immutable";
import parseDMS from 'parse-dms';

export const generateDynamicTemplate = (DataList, preDefinedStateName) => {
    let visibilities = [];
    let parsedDataList = [];

    DataList.map((data, index) => {
        parsedDataList[index] = parseDataFunctionRouter(data, preDefinedStateName, index);
        visibilities[index] = preDefinedStateName === "drillShipsLastLocations"; //default val
    })
    /*
        data = [ //her yapıya uygun olarak parse edecek fnclar farklı olur
            {
                "id":,
                "title":"",
                "location":"",
                "lastUpdatedDate":""
            },
        ]
    */
    return new Map({ "visibilities": visibilities, "data": parsedDataList })
}

const parseDataFunctionRouter = (data, preDefinedStateName, index) => {
    if (preDefinedStateName === "drillShipsLastLocations") {
        return parseDrillShipsLastLocationDataParse(data, preDefinedStateName, index)
    } else if (preDefinedStateName === "navtexAreas") {
        return parseNavtexAreasDataParse(data, preDefinedStateName, index)
    }
}

const parseDrillShipsLastLocationDataParse = (data, preDefinedStateName, index) => {
    const id = index;
    let content = data.content.rendered;
    const published_date = data.date; //date_gmt
    const link = data.link;
    const title = data.title.rendered;
    const belongingKey = preDefinedStateName;
    const imgUrl = data.fimg_url;
    content = content.replace(/<\/?[^>]+(>|$)/g, "").replace(/\&nbsp;/g, ''); //remove html tags
    content = content.substring(0, content.length - 1);//sondaki enter'ı sil
    let contentLines = content.split('\n');

    let contentData = {};
    let splitted = "";
    let splittedCoordinates = "";
    for (var i = 0; i < contentLines.length; i++) {
        splitted = contentLines[i].split("-");
        if (getStringBetweenSquareBrackets(splitted[0]) === "Konum") { //Konum olarak girilmeli kordinatlar
            splittedCoordinates = getStringBetweenSquareBrackets(splitted[1]).split(",");
            contentData["coordinates"] = [parseFloat(splittedCoordinates[0].trim()), parseFloat(splittedCoordinates[1].trim())]
        } else {
            contentData[`${getStringBetweenSquareBrackets(splitted[0])}`] = getStringBetweenSquareBrackets(splitted[1])
        }
    }
    contentData = {
        "id": id,
        "name": title,
        "title": title,
        "popupType": "featurePopupWImage",
        "popupSubInfo": `Son güncelleme: ${contentData["Son güncelleme"]}`,
        "imgUrl": imgUrl,
        "published_date": published_date,
        "link": link,
        "belongingKey": belongingKey,
        "markerIcon": "pin.png",
        "size": [12, 12],
        ...contentData,
    }

    return contentData
}
const parseNavtexAreasDataParse = (data, preDefinedStateName, index) => {

    const id = index;
    let content = data.content.rendered;
    const published_date = data.date; //date_gmt
    const link = data.link;
    const title = data.title.rendered;
    const belongingKey = preDefinedStateName;
    // content = content.replace(/<\/?[^>]+(>|$)/g, "").replace(/\&nbsp;/g, ''); //remove html tags
    // content = content.substring(0, content.length - 1);//sondaki enter'ı sil
    // let contentLines = content.split('\n');

    let contentData = {};
    // for (var i = 0; i < contentLines.length; i++) {
    //     splitted = contentLines[i].split("-");
    //     if (getStringBetweenSquareBrackets(splitted[0]) === "Konum") { //Konum olarak girilmeli kordinatlar
    //         splittedCoordinates = getStringBetweenSquareBrackets(splitted[1]).split(",");
    //         contentData["coordinates"] = [parseFloat(splittedCoordinates[0].trim()), parseFloat(splittedCoordinates[1].trim())]
    //     } else {
    //         contentData[`${getStringBetweenSquareBrackets(splitted[0])}`] = getStringBetweenSquareBrackets(splitted[1])
    //     }
    // }

    contentData = {
        "id": id,
        "name": title,
        "title": title,
        "popupType": "basic",
        "published_date": published_date,
        "link": link,
        "belongingKey": belongingKey,
        "positions": getPositions(content),
        "popupContent": title,
        "popupType": "basic",
        "styles": {
            color: '#fff',
            weight: 1,
            fillOpacity: 0.6,
            fillColor: '#EDF9FD'
        }
    }

    return contentData
}

const getStringBetweenSquareBrackets = (str) => {
    if (str !== undefined) {
        var matches = str.match(/\[(.*?)\]/);
        if (matches) {
            return matches[1];
        }
    }
    return "";
}


const getPositions = (str) => {
    let cleanText = str.replace(/<\/?[^>]+(>|$)/g, ""); //remove tags
    let _cleanText = cleanText.replace("&#8212;", "---").replace(/(\r\n|\n|\r)/gm, ""); //--- ve enterları sil

    var firstvariable = "Koordinatlar:";
    var secondvariable = "---";
    let a = _cleanText.match(new RegExp(firstvariable + "(.*)" + secondvariable)); // verilen iki değer arasını getir
    let coordinatesAsADegreeMinuteSecond = a[1].replace(/&#8217;/g, '\'').replace(/&#8243;/g, '\"').split(","); // ' ve " karakterlerini değiştir , ile arr'e böl
    let coordinatesAsALatLon = coordinatesAsADegreeMinuteSecond.map(coordinate => {
        let a = parseDMS(coordinate);
        return [a.lat, a.lon];
    });
    return coordinatesAsALatLon;
}
